import { useCallback } from "react";
import { useDispatch } from "react-redux";
//Local files
import { esignTemplatesActions } from 'features/esignTemplates';

const useEsignTemplates = () => {
  const dispatch = useDispatch();
  const getEsignTemplates = useCallback(({ offset }) => dispatch(esignTemplatesActions.getEsignTemplates({ offset })), [dispatch]);
  const getEsignTemplate = useCallback((id) => dispatch(esignTemplatesActions.getEsignTemplate(id)), [dispatch]);
  const createEsignTemplate = useCallback(esignTemplate => dispatch(esignTemplatesActions.createEsignTemplate(esignTemplate)), [dispatch]);
  const updateEsignTemplate = useCallback(esignTemplate => dispatch(esignTemplatesActions.updateEsignTemplate(esignTemplate)), [dispatch]);
  const deleteEsignTemplate = useCallback(id => dispatch(esignTemplatesActions.deleteEsignTemplate(id)), [dispatch]);
  const clearLocalEsignTemplates = useCallback(() => dispatch(esignTemplatesActions.clearLocalEsignTemplates()), [dispatch]);
  const clearLocalActiveEsignTemplate = useCallback(() => dispatch(esignTemplatesActions.clearLocalActiveEsignTemplate()), [dispatch]);

  return { 
    getEsignTemplates, 
    getEsignTemplate, 
    createEsignTemplate, 
    updateEsignTemplate, 
    deleteEsignTemplate, 
    clearLocalEsignTemplates, 
    clearLocalActiveEsignTemplate 
  };
};

export default useEsignTemplates;